import { transformDateToLocalDateString } from "helpers";
import { formatUnitPrice } from "services/api/pricing/consts";
import { PlatformTenant } from "services/api/platform/types";
import { Badge } from "ui/components/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const TENANT_TABLE_COLUMNS: Column[] = [
  {
    title: "Klijent",
    field: "name",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PlatformTenant) => (
      <div>
        <p className="text-slate-700">{row.name}</p>

        {row.tenantTypeName && (
          <p className="text-xs text-slate-400">{row.tenantTypeName}</p>
        )}
      </div>
    ),
  },
  {
    title: "Vozila",
    field: "vehicleCount",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PlatformTenant) => (
      <span className="text-slate-700">
        {row.vehicleCount}

        {row.draftVehicleCount > 0 && (
          <span className="text-xs text-slate-400"> ({row.draftVehicleCount} nacrt)</span>
        )}
      </span>
    ),
  },
  {
    title: "Korisnici",
    field: "userCount",
    sortable: true,
    type: ColumnTypes.string,
  },
  {
    title: "Računi",
    field: "invoiceCount",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PlatformTenant) => (
      <span className="text-slate-500">
        {row.outgoingInvoiceCount + row.incomingInvoiceCount}
      </span>
    ),
  },
  {
    title: "Grupa",
    field: "pricingSchemeName",
    type: ColumnTypes.custom,
    render: (row: PlatformTenant) =>
      row.pricingSchemeName ? (
        <Badge text={row.pricingSchemeName} variant="info" height="small" />
      ) : (
        <span className="text-xs text-slate-400">standardno</span>
      ),
  },
  {
    title: "Minimum",
    field: "minimumMonthly",
    sortable: true,
    type: ColumnTypes.custom,
    // Prazno znači da cijena nije razriješena — nula bi tvrdila da je besplatno.
    render: (row: PlatformTenant) => (
      <span className="whitespace-nowrap text-slate-700">
        {row.minimumMonthly === null ? "—" : formatUnitPrice.format(row.minimumMonthly)}
      </span>
    ),
  },
  {
    title: "Zadnja aktivnost",
    field: "lastActivity",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PlatformTenant) => (
      <span className="whitespace-nowrap text-slate-500">
        {row.lastActivity
          ? transformDateToLocalDateString(new Date(row.lastActivity))
          : "—"}
      </span>
    ),
  },
];
